import React from 'react'
import styled from 'styled-components'
import {IoIosQuote} from "react-icons/io";
import {AiOutlineStar} from "react-icons/ai";

const ClientSlider = (props) => {
    const {name, position, img_url, stars = 5, disc} = props.item; // default stars
    return (
        <Container>
            <Header>
                <span className='quote'></span>
                <div className="stars">
                    {Array(stars).fill().map((_, i) => (
                        <span className='star' key={i}></span>
                    ))}
                </div>
            </Header>
            <Body>
                {disc}
            </Body>
            <Footer>
                <img src={img_url} alt={name} />
                <div className="details">
                    <h1>{name}</h1>
                    <p>{position}</p>
                </div>
            </Footer>
        </Container>
    )
}

export default ClientSlider

const Container = styled.div`
    background: linear-gradient(159deg, rgb(45, 45, 58) 0%, rgb(43, 43, 53) 100%);
    padding: 1.5rem 1rem;
    margin: 0 1rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 350px; /* ensures all boxes have at least this height */
    box-sizing: border-box;
`

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    .quote{
        font-size: 2rem;
        color: #01be96;
        opacity: 0.7;
    }

    .stars{
        display: flex;
        gap: 0.2rem;
    }

    .star{
        color: #ffcd3c;
        font-size: 1.2rem;
    }
`

const Body = styled.p`
    font-size: 1rem;
    line-height: 1.5rem;
    text-align: center;
    padding: 0 1rem;
    margin-bottom: 1rem;
`

const Footer = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;

    img{
        width: 8rem;
        height: 4rem;
        object-fit: contain;
    }

    .details h1{
        font-size: 1.1rem;
        font-weight: 700;
        margin: 0;
        @media(max-width: 580px){
            font-size: 1rem;
        }
    }

    .details p{
        font-size: 0.8rem;
        color: rgba(255,255,255,0.5);
        margin: 0;
        @media(max-width: 538px){
            font-size: 0.6rem;
        }
    }
`